import * as React from 'react';

export interface EquationComponentProps {
    changeEquation: Function,
    equation: string,
    equationCursorPosition: number
    userIsOwner: boolean
    limitedEditing: boolean
}

const EquationComponent = (props: EquationComponentProps) => {

    return (
        <div className="row my-2">
            <div className="col">
                <b>Equation:</b>
                <textarea
                    disabled={!props.userIsOwner || props.limitedEditing }
                    id="equationInput"
                    className="form-control"
                    placeholder="Equation"
                    autoComplete="off"
                    rows={2}
                    value={props.equation}
                    onChange={e => props.changeEquation(e.target)}
                    onClick={e => props.changeEquation(e.target)}
                    onKeyUp={e => props.changeEquation(e.target)}
                >
                </textarea>
            </div>
        </div>
    )
}



export default EquationComponent;